// Google AdSense persistent bottom anchor banner. Slot is fixed-size
// (320x50 mobile, 728x90 desktop) so AdSense can only ever serve a
// horizontal banner — never a square or tall rectangle. On mobile the
// 320x50 slot is visually scaled up via CSS transform to fill the
// viewport width edge-to-edge; the ad creative stretches with it.

const PUBLISHER_ID = "ca-pub-6945982381535038";
const ANCHOR_SLOT = "3386334989";
const DESKTOP_BREAKPOINT = 768;
const MOBILE_BANNER_W = 320;
const MOBILE_BANNER_H = 50;

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

export function mountAnchor(): void {
  const host = document.getElementById("ad-anchor");
  if (!host) return;
  host.innerHTML = "";

  const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;

  const ins = document.createElement("ins");
  ins.className = "adsbygoogle";
  ins.setAttribute("data-ad-client", PUBLISHER_ID);
  ins.setAttribute("data-ad-slot", ANCHOR_SLOT);

  if (isDesktop) {
    ins.style.display = "inline-block";
    ins.style.width = "728px";
    ins.style.height = "90px";
  } else {
    // Block layout puts the ins at the container's left edge so the
    // top-left transform-origin scales toward the right edge cleanly.
    ins.style.display = "block";
    ins.style.width = `${MOBILE_BANNER_W}px`;
    ins.style.height = `${MOBILE_BANNER_H}px`;
    const scale = window.innerWidth / MOBILE_BANNER_W;
    ins.style.transformOrigin = "top left";
    ins.style.transform = `scale(${scale})`;
  }

  host.appendChild(ins);

  try {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  } catch {
    // AdSense throws if blocked or already filled — silent failure is fine.
  }
}
